import clsx from 'clsx';
import * as React from 'react';

export type ActionsProps = React.ComponentPropsWithoutRef<'div'>;

/**
 * Used to display a group of actions.
 * @example
 * <Actions>
 *  <Button label="Reply" />
 *  <Button label="Reply all" />
 * </Actions>
 */
export function Actions({
    ref,
    ...props
}: ActionsProps & { ref?: React.ForwardedRef<HTMLElement> }) {
    return (
        <section
            ref={ref}
            {...props}
            className={clsx('flex flex-wrap items-center justify-end gap-3', props.className)}
        />
    );
}
